"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onRouteUpdate = void 0;
require("./utils");
const onRouteUpdate = () => {
    window.___decentralandNavigationUpdates =
        window.___decentralandNavigationUpdates === undefined
            ? 0
            : window.___decentralandNavigationUpdates + 1;
};
exports.onRouteUpdate = onRouteUpdate;
